import { StyledSandboxBanner } from './styles';

export const SandboxWithData: React.FC = () => {
  return (
    <StyledSandboxBanner>
      <div className="content">Go realtime on your data</div>
    </StyledSandboxBanner>
  );
};
